import { Box, Group, ScrollArea, Stack } from '@mantine/core';

import { ContentLayout } from '@features/layout';
import classes from './Help.module.css';
import { helpData, HelpSectionEnum } from './helpData';
import { HelpSection } from './HelpSection';

export const Help: React.FC = () => {
  const rowStructure = [
    [HelpSectionEnum.BATCH_STATUS],
    [HelpSectionEnum.DECLARATION_STATUS, HelpSectionEnum.GOOD_ITEMS_STATUS],
    [HelpSectionEnum.ACTIONS],
    [HelpSectionEnum.TRANSIT_STATUS],
    [HelpSectionEnum.TRANSIT_ACTIONS],
    [HelpSectionEnum.VALUATION_INDICATORS],
    [HelpSectionEnum.TSD_STATUS],
    [HelpSectionEnum.NOTIFICATION_INDICATORS],
  ];

  return (
    <ContentLayout>
      <ContentLayout.Header>
        <ContentLayout.Title>Help</ContentLayout.Title>
      </ContentLayout.Header>

      <ContentLayout.SubHeader>
        <ScrollArea
          classNames={{
            root: classes.scrollAreaRoot,
          }}
          offsetScrollbars
        >
          <Box p="xl">
            {rowStructure.map((sectionsInRow, rowIndex) => (
              <Stack key={`row-${rowIndex}`} p="sm">
                <Group justify="space-between" align="flex-start" grow>
                  {sectionsInRow.map((sectionKey) => (
                    <HelpSection key={sectionKey} sectionTitle={sectionKey} {...helpData[sectionKey]} />
                  ))}
                </Group>
              </Stack>
            ))}
          </Box>
        </ScrollArea>
      </ContentLayout.SubHeader>
    </ContentLayout>
  );
};
